import DownloadSVG from '@public/icons/download.svg';
import PdfSVG from '@public/icons/pdf.svg';
import ZipSVG from '@public/icons/zip.svg';
import { Document } from '@/entities/document';
import { isPdf } from '@/shared/hooks/use-form-sender/validator/utils';
import { isArchive } from '@/shared/hooks/use-form-sender/validator/utils';
import { tp } from '@/shared/lib/typograf';
import Link from '../../shared/Link';
import Typografed from '../../shared/Typografed';

export type DownloadButtonProps = Document;

type Props = React.HTMLAttributes<HTMLElement> & {
    downloadButtonProps: DownloadButtonProps;
};

function DownloadButton({ downloadButtonProps }: Props) {
    const document = downloadButtonProps;
    const tpText = tp(document.title);
    const link = document.src;
    return (
        <div className="download-button ">
            {isArchive(link) ? (
                <div className="download-button__wrapper">
                    <Link
                        className="download-button__left"
                        target={isArchive(link) ? '_blank' : undefined}
                        rel={isArchive(link) ? 'noreferrer nofollow' : undefined}
                        download={isArchive(link) ? true : undefined}
                        href={link}
                    >
                        <ZipSVG />
                        <div className="text-xs">
                            <Typografed>{tpText}</Typografed>
                        </div>
                    </Link>

                    <DownloadSVG className="download-svg" />
                </div>
            ) : (
                <div className="download-button__wrapper">
                    <Link
                        className="download-button__left"
                        target={isPdf(link) ? '_blank' : undefined}
                        rel={isPdf(link) ? 'noreferrer nofollow' : undefined}
                        download={isPdf(link) ? true : undefined}
                        href={link}
                    >
                        <PdfSVG />
                        <div className="text-xs">
                            <Typografed>{tpText}</Typografed>
                        </div>
                    </Link>

                    <DownloadSVG className="download-svg" />
                </div>
            )}
        </div>
    );
}

export default DownloadButton;
